import type { ReactNode } from 'react';

/** One section's registry entry — the single source of truth for a section. */
export interface SectionDef {
  id: string;
  label: string; // shown in the Contents index
  eyebrow: string; // eyebrow caption next to the auto number
  render: () => ReactNode; // inner content; built only when data is present
}

interface ShellProps {
  id: string;
  num: number; // 1-based position; rendered as the zero-padded eyebrow number
  eyebrow: string;
  children: ReactNode;
}

/** Wraps a section with its anchor + auto-numbered eyebrow. Section content
 * components render inner content only; numbering/anchor live here so the
 * registry order is the single source of truth. */
export default function SectionShell({
  id,
  num,
  eyebrow,
  children,
}: ShellProps) {
  return (
    <section id={id} className="POST__ANALYSIS__section">
      <p className="POST__ANALYSIS__eyebrow">
        <span className="dot" />
        {String(num).padStart(2, '0')} · {eyebrow}
      </p>
      {children}
    </section>
  );
}
